import { useResetRecoilState } from 'recoil';
import { authTokenState } from '../../atoms/auth/auth.atom';
import { currentUserState } from '../../atoms/user/user.atom';
import { companyState } from '../../atoms/company/company.atom';

const useResetState = () => {
  const resetAuth = useResetRecoilState(authTokenState);
  const resetCurrentUser = useResetRecoilState(currentUserState);
  const resetCompanyState = useResetRecoilState(companyState);

  const resetAll = () => {
    resetAuth();
    resetCurrentUser();
    resetCompanyState();
  };

  return resetAll;
};

export default useResetState;
